// extracted by mini-css-extract-plugin
module.exports = {"heidiInfo":"heidiInfo-module--heidiInfo--rGlY-","contactHeidi":"heidiInfo-module--contactHeidi--b4DFL"};